import Swiper from "swiper";
import Modaal from "modaal";
import {TweenMax} from "gsap";
import {TimelineMax} from "gsap";
import ScrollMagic from "scrollmagic";
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
const controller = new ScrollMagic.Controller;
/**
 * AlphaCharge
 * @constructor
 */
class AlphaCharge {
  constructor() {

  }
  /**
   * サンプル
   */
  init() {
    this.kvSliderInit();

    $(".video-alphaCharge01").modaal({type:'video'});
    $(".video-alphaCharge02").modaal({type:'video'});
    
    $('.p-alphaCharge__detailComponentAccTtl').on('click', function () {
      $(this).next().stop().slideToggle();
      $(this).toggleClass('active');
    })
    
  }

  kvSliderInit(){
    //kvのスライダー
    new Swiper('.swiper-container--kvAlphaCharge', {
      loop: true,
      effect: "fade",
      speed: 800, //1秒かけながら次の画像へ移動
      autoplay: {
        delay: 3000, //2秒後に次の画像へ
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
    })
  }
};

export default AlphaCharge;